import produce from 'immer';
import { privacyStringOptions } from './constants';
export var getInitialState = function () { return ({
    loading: false,
    error: false,
    ios: { privacy_strings: [] },
    iosDropdownOptions: privacyStringOptions,
    iosDropdownSelection: null,
    iosEditing: false,
}); };
var filterDropdownOptions = function (currentState, privacyStrings) {
    var definedOptions = privacyStrings.reduce(function (acc, item) {
        if (!acc.includes(item.key)) {
            acc.push(item.key);
        }
        return acc;
    }, []);
    return currentState.iosDropdownOptions.filter(function (v) { return !definedOptions.includes(v.value); });
};
export var publishConfigReducer = function (currentState, action) {
    if (currentState === void 0) { currentState = getInitialState(); }
    return produce(currentState, function (state) {
        switch (action.type) {
            case 'publishConfig/FETCH_IOS_CONFIG_REQUEST': {
                var initialState = getInitialState();
                state.ios = initialState.ios;
                state.iosDropdownOptions = initialState.iosDropdownOptions;
                state.loading = true;
                state.error = false;
                break;
            }
            case 'publishConfig/FETCH_IOS_CONFIG_SUCCESS': {
                state.ios = action.payload;
                state.iosDropdownOptions = filterDropdownOptions(currentState, action.payload.privacy_strings);
                state.iosDropdownSelection = null;
                state.loading = false;
                state.error = false;
                break;
            }
            case 'publishConfig/FETCH_IOS_CONFIG_FAIL':
                state.loading = false;
                state.error = true;
                break;
            case 'publishConfig/UPSERT_IOS_CONFIG_REQUEST':
                state.loading = true;
                state.error = false;
                break;
            case 'publishConfig/UPSERT_IOS_CONFIG_SUCCESS':
                state.ios = action.payload;
                state.iosDropdownOptions = filterDropdownOptions(currentState, action.payload.privacy_strings);
                state.iosDropdownSelection = null;
                state.iosEditing = false;
                state.loading = false;
                state.error = false;
                break;
            case 'publishConfig/UPSERT_IOS_CONFIG_FAIL':
                state.loading = false;
                state.error = true;
                break;
            case 'publishConfig/CLEAR_IOS_CONFIG_REQUEST':
                state.loading = true;
                state.error = false;
                break;
            case 'publishConfig/CLEAR_IOS_CONFIG_SUCCESS': {
                var initialState = getInitialState();
                state.ios = initialState.ios;
                state.iosDropdownOptions = initialState.iosDropdownOptions;
                state.iosDropdownSelection = null;
                state.iosEditing = false;
                state.loading = false;
                state.error = false;
                break;
            }
            case 'publishConfig/CLEAR_IOS_CONFIG_FAIL':
                state.loading = false;
                state.error = true;
                break;
            case 'publishConfig/IOS_CONFIG_ADD':
                if (action.payload) {
                    state.ios.privacy_strings.push({ key: action.payload, value: null });
                    state.iosDropdownOptions = filterDropdownOptions(state, state.ios.privacy_strings);
                    state.iosDropdownSelection = null;
                }
                break;
            case 'publishConfig/IOS_CONFIG_REMOVE':
                state.ios.privacy_strings = currentState.ios.privacy_strings.filter(function (v) { return v.key !== action.payload; });
                break;
            case 'publishConfig/IOS_CONFIG_MODIFY': {
                var toModify = currentState.ios.privacy_strings.findIndex(function (v) { return v.key === action.payload.key; });
                if (toModify > -1) {
                    state.ios.privacy_strings[toModify].value = action.payload.value;
                }
                break;
            }
            case 'publishConfig/IOS_CONFIG_ENABLE_EDITING':
                state.iosEditing = true;
                break;
            case 'publishConfig/IOS_CONFIG_CANCEL_EDITING':
                state.iosEditing = false;
                state.iosDropdownSelection = null;
                break;
        }
    });
};
